<nav class="navbar sticky-top navbar-static-top menu-light" role="navigation">
    <div class="container">
      <div class="" id="navbarColor02">
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
          <li class="nav-item">
            <a class="nav-link active" href="#" routerLink="/">INICIO</a>
          </li>
          <li class="nav-item" >
            <a class="nav-link" href="#" routerLink="/about">A CERCA DE</a>
          </li>
        </ul>
        <ul class="navbar-nav my-2 my-lg-0" > 
          
        </ul>
      </div>
    </div>
   

  </nav>

  
  